// extracted by css-extract-rspack-plugin
export default {"cls1":"FreeformQuestion-cls1_oPt","cls2":"FreeformQuestion-cls2_36a FreeformQuestion-cls1_oPt","labeled":"FreeformQuestion-labeled_IcS"};